import React, { useState, useEffect } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import { Loader, Message, Icon, Button } from 'semantic-ui-react'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'
import './PDFViewer.css'

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

const PDFViewer = ({ documentUrl, documentName, onError }) => {
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [scale, setScale] = useState(1.0)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
    setLoading(false)
    setError(null)
  }

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error)
    setError(error.message || 'Failed to load PDF')
    setLoading(false)
    if (onError) {
      onError(error)
    }
  }

  const zoomIn = () => {
    setScale(prevScale => Math.min(prevScale + 0.2, 3.0))
  }

  const zoomOut = () => {
    setScale(prevScale => Math.max(prevScale - 0.2, 0.5))
  }

  const resetZoom = () => {
    setScale(1.0)
  }

  if (!documentUrl) {
    return (
      <Message info>
        <Message.Header>No Document Selected</Message.Header>
        <p>Please select a document from the list to view it here.</p>
      </Message>
    )
  }

  return (
    <div className="pdf-viewer-container">
      {/* Toolbar */}
      <div className="pdf-toolbar">
        <div className="pdf-title">
          <Icon name="file pdf outline" />
          {documentName || 'PDF Document'}
        </div>
        <div className="pdf-controls">
          <Button.Group size="mini">
            <Button icon="zoom out" onClick={zoomOut} title="Zoom Out" />
            <Button onClick={resetZoom} title="Reset Zoom">
              {Math.round(scale * 100)}%
            </Button>
            <Button icon="zoom in" onClick={zoomIn} title="Zoom In" />
          </Button.Group>
          {numPages && (
            <span className="page-info">
              Page {pageNumber} of {numPages}
            </span>
          )}
        </div>
      </div>

      {/* PDF Document */}
      <div className="pdf-document-wrapper">
        {loading && (
          <div className="pdf-loading">
            <Loader active inline="centered">
              Loading PDF...
            </Loader>
          </div>
        )}

        {error && (
          <Message negative>
            <Message.Header>Error Loading PDF</Message.Header>
            <p>{error}</p>
          </Message>
        )}

        <Document
          file={documentUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={onDocumentLoadError}
          loading=""
          className="pdf-document"
        >
          {/* Render all pages */}
          {numPages && !error && (
            <div className="pdf-pages">
              {Array.from(new Array(numPages), (el, index) => (
                <div key={`page_${index + 1}`} className="pdf-page-container">
                  <div className="page-number-label">Page {index + 1}</div>
                  <Page
                    pageNumber={index + 1}
                    scale={scale}
                    className="pdf-page"
                    renderTextLayer={true}
                    renderAnnotationLayer={true}
                  />
                </div>
              ))}
            </div>
          )}
        </Document>
      </div>
    </div>
  )
}

export default PDFViewer